import { Injectable } from '@angular/core';
import { InAppBrowser, InAppBrowserOptions } from '@ionic-native/in-app-browser';
import { ModalController } from 'ionic-angular';
import { VisitorModalPage } from '../pages/visitor-modal/visitor-modal';
import { environment } from '../environments/environment';

@Injectable()
export class UtilService {

  options : InAppBrowserOptions = {
    location : 'no',//Or 'no' 
    hidden : 'no', //Or  'yes'
    clearcache : 'yes',
    clearsessioncache : 'yes',
    zoom : 'no',//Android only ,shows browser zoom controls 
    hardwareback : 'no',
    mediaPlaybackRequiresUserAction : 'no',
    shouldPauseOnSuspend : 'no', //Android only 
    closebuttoncaption : 'Close', //iOS only
    disallowoverscroll : 'no', //iOS only 
    toolbar : 'yes', //iOS only 
    enableViewportScale : 'no', //iOS only 
    allowInlineMediaPlayback : 'no',//iOS only 
    presentationstyle : 'pagesheet',//iOS only 
    fullscreen : 'yes',//Windows only 
  };

  constructor(private inAppBrowser: InAppBrowser, private modalCtrl: ModalController) {
  }

  openWithInAppBrowser(url : string){
    let target = "_system";
    this.inAppBrowser.create(url,target,this.options);
  }
  openUrl(url : string, target : string){
    this.inAppBrowser.create(url,target,this.options);
  }

  isImage(url:string){
    if(url.slice(-3)=='png' || url.slice(-3)=='jpg' || url.slice(-4)=='jpeg' || url.slice(-3)=='PNG' || url.slice(-3)=='JPG' || url.slice(-4)=='JPEG'){
      return true;
    }else{
      return false;
    }
  }

  showPopup(title: string, message: string){
    let profileModal = this.modalCtrl.create(VisitorModalPage, {
      message: message,
      title: title
    });
    profileModal.present();
  }

  showNoInternet(exitApp = false){
    // let profileModal = this.modalCtrl.create(VisitorModalPage, {
    //   message: 'Please, check your internet connection and try again.',
    //   title: 'error!',
    //   exitApp
    // });
    // profileModal.present();
  }

  getShortDate(value){
    let date = new Date(value.replace(/-/g, "/"));
    let month_names =["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];
    
    var day = date.getDate();
    var month_index = date.getMonth();
    var year = date.getFullYear();
    
    return day + " " + month_names[month_index] + " " + year ;
  }

  clearNavStack(navCtrl){
    const removeIndex = navCtrl.getActive().index - 1;
    navCtrl.remove(1, removeIndex);
  }
  onErrorLogo(){
    return 'assets/images/logo/ism'+environment.icon+'.png';
  }
}



// WEBPACK FOOTER //
// ./src/services/util.ts